import { SliceZone } from '@prismicio/react';
import Head from 'next/head';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import smoothscroll from 'smoothscroll-polyfill';

import { BottomCtaSlice } from './BottomCtaSlice';
import { HeroSlice } from './HeroSlice';
import { LogosSlice } from './LogosSlice';
import { OverviewSlice } from './OverviewSlice';
import { PartnersSlice } from './PartnersSlice';
import { QuoteSlice } from './QuoteSlice';

import { FooterOnlyLayout } from '@/layouts/FooterOnly';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const components = {
  hero_section: HeroSlice,
  overview_section: OverviewSlice,
  integration_slice: PartnersSlice,
  cta_with_logos: LogosSlice,
  quote_section: QuoteSlice,
  bottom_cta: BottomCtaSlice,
};

export function SwitchToRemotePage(document) {
  const { body } = document;
  const applyFormRef = useRef();

  return (
    <>
      <DocumentHead document={document} noIndex />
      <Head>
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-remote-sans.css')} />
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-bossa.css')} />
      </Head>
      <SliceZone slices={body} components={components} context={{ applyFormRef }} />
    </>
  );
}

SwitchToRemotePage.Layout = FooterOnlyLayout;
